"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSportDigestGroupDto = instanceOfSportDigestGroupDto;
exports.SportDigestGroupDtoFromJSON = SportDigestGroupDtoFromJSON;
exports.SportDigestGroupDtoFromJSONTyped = SportDigestGroupDtoFromJSONTyped;
exports.SportDigestGroupDtoToJSON = SportDigestGroupDtoToJSON;
exports.SportDigestGroupDtoToJSONTyped = SportDigestGroupDtoToJSONTyped;
var DigestItemDto_1 = require("./DigestItemDto");
/**
 * Check if a given object implements the SportDigestGroupDto interface.
 */
function instanceOfSportDigestGroupDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('digests' in value) || value['digests'] === undefined)
        return false;
    return true;
}
function SportDigestGroupDtoFromJSON(json) {
    return SportDigestGroupDtoFromJSONTyped(json, false);
}
function SportDigestGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'code': json['code'],
        'digests': (json['digests'].map(DigestItemDto_1.DigestItemDtoFromJSON)),
    };
}
function SportDigestGroupDtoToJSON(json) {
    return SportDigestGroupDtoToJSONTyped(json, false);
}
function SportDigestGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'digests': (value['digests'].map(DigestItemDto_1.DigestItemDtoToJSON)),
    };
}
